import { WpTaxonomyValue } from "@hooks/use-get/taxonomy-values";

export type FieldOptions =
  | []
  | {
      editor_class: string;
      dfw: boolean;
    }
  | {
      [key: string]: string | boolean;
    }
  | { value: string | number; label: string }[];

export type WpFieldConfig = {
  id: string;
  name: string;
  options: FieldOptions;
  clone: boolean;
  type: string;
  multiple: boolean;
  field_name: string;
  placeholder: string;
  /** Backend-controlled visibility — false means the field should never
   * reach the frontend's tables/filters/charts (e.g. integration-only fields). */
  display?: boolean;
  queryArgs?: {
    taxonomy?: string[];
    [key: string]: any;
  };
  field_type: string;
  taxonomy?: string[] | WpTaxonomyValue[];
  js_options?: {
    timeFormat: string;
    dateFormat: string;
    showButtonPanel: boolean;
    changeYear: boolean;
    yearRange: string;
    changeMonth: boolean;
    controlType: string;
    firstDay: number;
    placeholder?: string;
  };
  fields?: WpFieldConfig[];
  ajax?: {
    url?: string;
  };
  ajax_data?: {
    field?: {
      id: string;
      type: string;
      query_args: {
        number: number;
        post_status: string;
      };
      display_field: string;
    };
  };
};

export enum WpBoolean {
  YES = "1",
  NO = "0",
}
